var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fas mr-2 my-color",class:_vm.getIcon(_vm.fieldObj.type)}),_vm._v(" "+_vm._s(_vm.fieldObj.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }